import { useDispatch, useSelector } from "react-redux";
import { Download, FileText, Shield, BookOpen, Tag } from "lucide-react";

import { SET_MESSAGE } from "@/redux/types/message.types";
import CustomDropdown from "@/components/desktop/list/dropdown/CustomDropdown";

const InventoryDownload = ({ detail, index, index_detail }) => {
	const dispatch = useDispatch();
	const { inventories } = useSelector((state) => state.inventory);

	const downloadDocument = (name_document) => {
		if (!inventories[index].details[index_detail][name_document]) {
			dispatch({
				type: SET_MESSAGE,
				payload: {
					message: "No existe un documento asociado para descargar.",
					type: "info",
				},
			});
		} else {
			window.open(inventories[index].details[index_detail][name_document]);
		}
	};

	const items = [
		...(detail.URL_TAG
			? [
					{
						label: "Etiqueta",
						action: () => downloadDocument("URL_TAG"),
						icon: Tag,
					},
				]
			: []),
		...(detail.URL_DATA_SHEET
			? [
					{
						label: "Ficha técnica",
						action: () => downloadDocument("URL_DATA_SHEET"),
						icon: FileText,
					},
				]
			: []),
		...(detail.URL_SAFETY_SHEET
			? [
					{
						label: "Hoja de seguridad",
						action: () => downloadDocument("URL_SAFETY_SHEET"),
						icon: Shield,
					},
				]
			: []),
		...(detail.URL_BROCHURE
			? [
					{
						label: "Folleto",
						action: () => downloadDocument("URL_BROCHURE"),
						icon: BookOpen,
					},
				]
			: []),
	];

	return <CustomDropdown items={items} align="right" triggerIcon={Download} />;
};

export default InventoryDownload;
